<template>
  <div class="app-text" v-html="txt"></div>
</template>
<script>
export default{
  data(){
    return{
      txt:''
    }
  },
  mounted(){
    this.getPage();
  },
  methods:{
    getPage(){
      let vm = this;
      vm.ajax("page", "get", 'id=1', e => {
        vm.txt = e.data.content
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/protocol.vue